import { StyleSheet } from 'aphrodite';
import {
	background,
	brandPrimaryHover,
	brandPrimaryText,
	brandSecondary,
	header,
	mention,
	mentionDark,
	titles,
	white,
} from '../../../web/styles/colors';
import { BreakPoints, CssSelectors, baseStyleSheet } from '../../../web/styles/styles';

const headerHeight = 60;
export const styleSheet = StyleSheet.create({
	accountDetails: {
		display: 'flex',
		flexDirection: 'column',
	},
	button: {
		alignSelf: 'flex-end',
		marginBottom: 10,
		marginTop: 40,
	},
	circle: {
		':not:first': {
			paddingLeft: 6,
		},
	},
	citationContentBox: {
		[BreakPoints.phoneCompactHeight]: {
			height: 'auto',
			maxHeight: 450,
		},
		background,
		boxSizing: 'border-box',
		color: 'black',
		fontSize: 14,
		height: 450,
		marginBottom: 20,
		marginTop: 25,
		minHeight: 200,
		overflow: 'auto',
		overflowWrap: 'break-word',
		padding: 8,
		whiteSpace: 'pre-wrap',
		width: '100%',
		wordBreak: 'break-word',
		wordWrap: 'break-word',
	},
	citationModal: {
		alignItems: 'center',
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
		padding: 0,
		width: '100%',
		zIndex: 5,
	},
	citationModalCloseButton: {
		margin: 'auto',
	},
	closeButton: {
		marginLeft: 5,
	},

	container: {
		background: 'white',
		height: '100%',
	},
	containerCitation: {
		[BreakPoints.phoneCompactWidth]: {
			minWidth: 'inherit',
			width: '90vw',
		},
		[BreakPoints.phoneCompactHeight]: {
			width: '90vh',
		},
		background: 'white',
		border: '1px solid #BABABA',
		boxShadow: '0 2px 6px 0 rgba(0,0,0,0.20)',
		boxSizing: 'border-box',
		maxHeight: '100%',
		minWidth: 500,
		padding: 20,
	},
	contentBoxTitle: {
		color: brandPrimaryHover,
		fontSize: 16,
		fontWeight: 600,
		margin: 0,
	},
	copyLinkButton: {
		background: brandSecondary,
		borderRadius: 3,
		color: white,
		fontSize: 14,
		padding: 10,
		paddingLeft: 20,
		paddingRight: 20,
	},
	copyLinkField: {
		background: white,
		border: 'none',
		fontSize: 11,
		marginBottom: 25,
		marginTop: 15,
		maxWidth: 550,
		paddingBottom: 6,
		paddingTop: 6,
		...CssSelectors.allChildren(
			{
				fontSize: 11,
			},
			'input'
		),
	},
	disclaimerText: {
		fontSize: 12,
		paddingBottom: 20,
		textAlign: 'center',
		width: '60%',
	},
	iconRow: {
		alignItems: 'center',
		display: 'flex',
		height: 40,
		margin: '0 auto',
		padding: 4,
		...CssSelectors.allChildren(
			{
				height: 24,
			},
			'img'
		),
	},
	iconRowSelected: {
		...CssSelectors.allChildren(
			{
				height: 38,
				opacity: 1,
			},
			'img'
		),
	},
	iconRowUnselected: {
		...CssSelectors.allChildren(
			{
				height: 30,
				opacity: 0.5,
			},
			'img'
		),
	},
	icons: {
		display: 'flex',
	},
	iconSection: {
		[BreakPoints.phoneCompactWidth]: {
			paddingLeft: 20,
		},
		marginTop: 25,
	},
	iconToggle: {
		alignItems: 'center',
		display: 'flex',
		...CssSelectors.allChildren(
			{
				height: 30,
				padding: 4,
				paddingRight: 8,
			},
			'img'
		),
	},
	iconToggleNotSelected: {
		...CssSelectors.allChildren(
			{
				opacity: 0.5,
			},
			'img'
		),
	},
	imageDisplayAreaPreview: {
		borderBottomLeftRadius: 10,
		borderBottomRightRadius: 10,
		boxSizing: 'border-box',
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'flex-start',
		overflow: 'hidden',
		padding: 0,
		position: 'relative',
		...CssSelectors.allDescendants(
			{
				objectFit: 'cover',
				paddingBottom: 2,
			},
			'img'
		),
		...CssSelectors.allDescendants(
			{
				display: 'flex',
			},
			'button'
		),
	},
	imageDisplayAreaPreviewColWrap: {
		flexDirection: 'column',
		height: 372,
	},
	imageDisplayAreaPreviewInstagram: {
		justifyContent: 'center',
		...CssSelectors.allDescendants(
			{
				maxHeight: 'auto',
				padding: 0,
			},
			'img'
		),
	},
	imageDisplayLeft: {
		paddingLeft: 2,
	},
	loadingContainer: {
		align: 'center',
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
		...CssSelectors.allChildren({
			margin: 'auto',
		}),
	},
	modalContent: {
		alignItems: 'flex-end',
		backgroundColor: 'white',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		padding: 10,
		zIndex: 5,
	},
	modalOverlay: {
		alignItems: 'center',
		background: 'rgba(0, 0, 0, 0.5)',
		display: 'flex',
		inset: 0,
		height: '100%',
		justifyContent: 'center',
		position: 'fixed',
		width: '100%',
	},
	pointLeft: {
		height: 15,
		transform: 'rotateZ(90deg)',
		width: 20,
	},
	pointRight: {
		height: 15,
		transform: 'rotateZ(270deg)',
		width: 20,
	},
	previewContainer: {
		[BreakPoints.phoneCompactWidth]: {
			display: 'flex',
			flexDirection: 'column',
			minHeight: `calc(100% - ${headerHeight}px)`,
			overflowY: 'auto',
		},
		display: 'flex',
		flexDirection: 'row',
		minHeight: `calc(100% - ${headerHeight}px)`,
	},
	previewContainerHeader: {
		[BreakPoints.phoneCompactWidth]: {
			fontSize: 20,
			paddingLeft: 16,
		},
		alignItems: 'center',
		borderBottom: `1px solid ${mentionDark}`,
		boxSizing: 'border-box',
		color: brandPrimaryText,
		display: 'flex',
		fontSize: 24,
		height: headerHeight,
		paddingBottom: 5,
		paddingLeft: 30,
	},
	previewContentBox: {
		background: white,
		borderRadius: 10,
		color: 'black',
		fontSize: 14,
		marginBottom: 20,
		marginTop: 12,
		opacity: 1,
		overflowWrap: 'break-word',
		transform: 'translate3d(0,0,0)',
		transition: 'opacity 0.2s, transform 0.5s',
		whiteSpace: 'pre-wrap',
		width: 372,
		wordBreak: 'break-word',
		wordWrap: 'break-word',
	},
	previewContentBoxInstagram: {
		paddingBottom: 250,
	},
	previewContentContainer: {
		alignItems: 'center',
		background: mention,
		color: brandPrimaryText,
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		fontSize: 16,
		paddingTop: 30,
		...CssSelectors.allChildren(
			{
				color: brandPrimaryText,
			},
			'span'
		),
	},
	previewContentTitle: {
		fontSize: 16,
	},
	previewHeader: {
		margin: '0 auto',
	},
	previewLinkContainer: {
		[BreakPoints.phoneCompactWidth]: {
			marginTop: 20,
			paddingBottom: 20,
			paddingLeft: 10,
			paddingRight: 10,
		},
		alignItems: 'center',
		color: brandPrimaryText,
		...baseStyleSheet.fontBold,
		fontSize: 12,
		marginTop: 50,
	},
	previewSideContainer: {
		[BreakPoints.phoneCompactWidth]: {
			overflow: 'visible',
			padding: 8,
			paddingTop: 10,
			width: '100%',
		},
		[BreakPoints.forMaxWidth(800)]: {
			minWidth: 0,
		},
		background: '#F8F8F8',
		boxSizing: 'border-box',
		color: brandPrimaryText,
		display: 'flex',
		flexDirection: 'column',
		maxHeight: '100%',
		minWidth: 264,
		overflowY: 'auto',
		padding: 34,
		paddingLeft: 20,
		paddingTop: 38,
		width: '30%',
		...CssSelectors.allDescendants(
			{
				paddingRight: 10,
			},
			'img'
		),
	},
	sideHeader: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
	},
	tab: {
		alignItems: 'center',
		boxSizing: 'border-box',
		color: header,
		cursor: 'pointer',
		display: 'flex',
		flexShrink: 0,
		fontSize: 12,
		justifyContent: 'center',
		letterSpacing: 1.05,
		maxHeight: 0,
		textTransform: 'uppercase',
		visibility: 'hidden',
		whiteSpace: 'nowrap',
	},
	tabNavigation: {
		...CssSelectors.allChildren(
			{
				paddingLeft: 6,
			},
			':not(:first-child), label'
		),
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
		marginBottom: 10,
		marginTop: 12,
		position: 'relative',
		top: 250,
	},
	tabSelected: {
		color: brandPrimaryHover,
		maxHeight: 'auto',
		position: 'fixed',
		visibility: 'visible',
	},
	targetLocation: {
		color: brandPrimaryText,
		fontSize: 14,
	},
	targetName: {
		color: titles,
		fontSize: 14,
	},
	textOnlyPadding: {
		padding: 14,
	},
	textPadding: {
		padding: 24,
		paddingBottom: 0,
	},
	title: {
		fontSize: 18,
		paddingRight: 14,
		[BreakPoints.phoneCompactWidth]: {
			fontSize: 14,
		},
	},

	topImage: {
		paddingBottom: 2,
	},
	signatureContent: {
		padding: '0 14px 14px 14px',
		fontSize: 'inherit',
		color: 'inherit',
		whiteSpace: 'pre-wrap',
		wordBreak: 'break-word',
		wordWrap: 'break-word',
	},
	disclosureContent: {
		padding: '0 14px 14px 14px',
		fontSize: 'inherit',
		color: 'inherit',
		whiteSpace: 'pre-wrap',
		wordBreak: 'break-word',
		wordWrap: 'break-word',
		marginTop: 4,
	},
});
